export default {
  login: 'Connexion',
  phoneNumberInputPlaceholder: 'Votre cellulaire',
  confirmationCodeInputPlaceholder: 'Code de confirmation',
  sendCodeButton: 'Envoyer code',
  sendCodeTitle: {
    1: 'Vous avez un compte ',
    2: 'Appyhere pour Recruteurs',
    3: '?',
  },
  sendCodeSubtitle: 'Entrez le même numéro de cellulaire utilisé pour recevoir un code',
  sendCodeSignUpSubtitle: 'Entrez votre numéro de téléphone mobile pour recevoir un code',
  sendCodeFooterLabel: {
    1: 'Vous ',
    2: 'DEVEZ ',
    3: "configurer un compte employeur avant d'utiliser l'application",
  },
  sendCodeFooterButton: "Appuyez ici pour plus d'informations",
  loginTitle: 'Vous avez reçu un code sur votre téléphone cellulaire',
  loginSubtitle: 'Entrez-le et tous vos nouveaux messages apparaîtront',
  loginFooterLabel: "Vous n'avez pas reçu de code sur votre téléphone cellulaire?",
  loginFooterButton: 'Renvoyer le code',
  wrongCountryCode: "AppyHere n'est pas disponible dans votre pays.",
  wrongCode: '* MAUVAIS CODE, RÉESSAYER',
  invalid_user_alert_title: 'Quelque chose ne va pas',
  invalid_user_alert_description: "Nous n'avons pas trouvé de compte, veuillez réessayer",
  signUpLabel: 'Inscription',
  signUpSendCodeTitle: "S'inscrire à Appyhere",
  signUpSendCodeSubTitle: "Simplifiez votre processus d'embauche et recrutez plus rapidement",
  continue: 'Continue',
  termsOfService: `En vous inscrivant à AppyHere, vous acceptez nos <1>  conditions d'utilisation</1>.`,
  privacyTerms1: 'Nous utilisons votre numéro de téléphone seulement pour vous identifier.',
  privacyTerms2: `Nous ne vendons ni n'utilisons votre numéro de téléphone à des fins de commercialisation.`,
  haveEmailAccount: 'Vous avez un compte e-mail sur Appyhere ?',
  enterEmailPassword: 'Entrez la même adresse e-mail et le mot de passe pour vous connecter.',
  emailLoginMode: 'Mode de connexion par e-mail',
  genericCodeSendErrorMessage: "Impossible d'envoyer le code de confirmation. Veuillez réessayer.",
  invalidConfirmationCodeMessage: 'Code de confirmation invalide',
  genericLoginErrorMessage: 'Impossible de se connecter',
  signUp: {
    signUpTitle: 'Bienvenue chez AppyHere',
    signUpSubTitle: 'Entrez vos renseignements',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    emailAddress: 'Adresse courriel',
    submitText: 'Joindre Appyhere',
    firstNameRequiredMessage: 'Le prénom est requis',
    lastNameRequiredMessage: 'Le nom de famille est requis',
    emailAddressRequiredMessage: 'Le courriel est requis',
    emailAddressValidateMessage: 'Le courriel doit être un format valide',
    passwordRequiredMessage: 'Le mot de passe est requis',
    passwordMinLengthMessage: 'Le mot de passe doit contenir au moins 6 caractères',
    signUpSuccessMessage: 'Vous vous êtes inscrit avec succès',
    genericSignUpErrorMessage: "Impossible de s'inscrire, veuillez réessayer",
    emailSignUpMode: 'Mode d’inscription par e-mail',
    invalidEmailFormatMessage: 'Veuillez saisir une adresse e-mail valide',
    invalidEmailTldMessage: "L'adresse e-mail doit se terminer par .com ou .net",
    emailLocalPartLengthExceeded: `La partie avant le « @ » ne peut pas dépasser 64 caractères.`,
    emailTotalLengthExceeded: `La longueur totale de l'adresse e-mail ne peut pas dépasser 254 caractères.`,
    requiredTldDescription: 'Nécessite .com ou .net comme domaine racine (étiquette supplémentaire autorisée)',
  },
  seeker_exists_heading_with_name: 'Salut {{firstName}} ! Bon retour sur AppyHere.',
  seeker_exists_heading_without_name: 'Hello! We recognize your account',
  seeker_exists_subheading:
    "Il semble que vous possèdez déjà un compte candidat. Vous essayez actuellement d'accéder à l'expérience recruteur. Est-ce intentionnel ? Choisis comment vous souhaitez continuer :",
  seeker_modal_job_search_portal_title: "Recherche d'emploi AppyHere",
  seeker_modal_find_a_job_button: 'Trouver un emploi',
  seeker_modal_job_search_portal_description:
    'Clique sur le bouton ci-dessus pour consulter les offres publiées par les employeurs sur AppyHere.',
  seeker_modal_recruiter_platform_title: 'AppyHere pour les recruteurs',
  seeker_modal_create_recruiter_account_button: 'Créer un compte recruteur',
  seeker_modal_recruiter_platform_description:
    'Clique sur le bouton ci-dessus pour commencer à publier des offres, gérer votre bassin de candidats et recruter du talent.',
};
